/**
 * created by athukorala on 9/12/19
 */
import React, {Component} from 'react';
import './AzureSyncUsers.css'
import Modal from "../../../../components/Modal/Modal";
import {Col, Row} from "reactstrap";
import {Empty} from "antd";
import {MDBDataTable} from "mdbreact";

class App extends Component {
  render() {
    let responseObj = this.props.azureResponse;

    let totalCount = 0;
    let unsavedUserCount = 0;
    let savedUserCount = 0;
    let unsavedUserList = [];

    if (responseObj !== null) {
      totalCount = responseObj.totalCount;
      unsavedUserList = responseObj.unsavedUserList;
      unsavedUserCount = unsavedUserList.length;
      savedUserCount = totalCount - unsavedUserList.length
    }

    let rows = [];
    if(unsavedUserList.length !== 0){
      unsavedUserList.map((user,index)=>{
        const obj = {
          _:user.azureId,
          _1:user.displayName,
          _2:user.reason
        };
        rows.push(obj)
      })
    }
    let data = {columns: columns, rows: rows};

    return (
      <Modal isOpen={true} toggle={() => this.props.closeModal(null)} size="lg" header="Azure sync user details">
        <Row>
          <Col className={"azure-sync-dashboard-column_1"}>
            <div className={"azure-sync-dashboard azure-sync-dashboard-saved"}>
              <h1 className={"azure-sync-dashboard-title"}>Saved User Count</h1>
              <h1 className={"azure-sync-dashboard-text"}>{savedUserCount}</h1>
            </div>
          </Col>
          <Col className={"azure-sync-dashboard-column_2"}>
            <div className={"azure-sync-dashboard azure-sync-dashboard-unsaved"}>
              <h1 className={"azure-sync-dashboard-title"}>Un-Saved User Count</h1>
              <h1 className={"azure-sync-dashboard-text"}>{unsavedUserCount}</h1>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <p className={"unsaved-users-text"}>Un-saved users details</p>

            {
              unsavedUserCount === 0 ?
                <Empty description={"Records not found"} className={"empty-icon"}/>:
                <div className={"azure-sync-users-table-wrapper"}>
                  <MDBDataTable
                    searching={true}
                    searchLabel={"Search User"}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    bordered
                    hover
                    data={data}/>
                </div>
            }

          </Col>
        </Row>
      </Modal>
    );
  }
}
const columns = [
  {
    label: 'Azure Id',
    field: '_',
    sort: 'asc'
  },
  {
    label: 'Display Name',
    field: '_1',
    sort: 'asc'
  },
  {
    label: 'Reason',
    field: '_2',
    sort: 'asc'
  },
];

export default App;
